export enum FreightPriceType {
  PRICE = 'priceType',
  PERCENTAGE = 'percentageType',
}
